/* eslint-disable */
import moment from 'moment';
import { apiRequest } from '@/calls/helpers';

const requestStock = async (requests) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'POST',
      endpoint: '/shop/products',
      data: { requests }
    });

    return {
      success: true,
      data: request.response[0]
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const resetOrder = async (orderid) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'DELETE',
      endpoint: '/shop/products/',
      data: { orderid }
    });

    return {
      success: true,
      data: request.response[0]
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getOrder = async (id) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: `/shop/orders/${id}`
    });

    const products = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/shop/products',
      data: {
        orderid: id
      }
    });

    const data = request.response;
    data.tickets = products.response.map(p => {
      const product = {
        id: p.id,
        title: p.ticket.positionlabel,
        category: p.category.label,
        price: {
          value: p.price.value.amount / 100,
          label: p.price.label
        },
        data: p
      };

      return product;
    });

    if (data.tickets.length > 0) {
      const t = data.tickets[0];
      const stock = await apiRequest('sapiti.php', {
        method: 'GET',
        endpoint: `/shop/products/stocks/${t.data.stockid}`
      });

      if (stock && stock.response) {
        const { eventid } = stock.response;

        const event = await apiRequest('sapiti.php', {
          method: 'GET',
          endpoint: `/agenda/events/${eventid}`
        });

        if (event && event.response) {
          moment.locale('FR');
          const eventData = event.response;

          data.event = {
            label: moment(eventData.starttime).format('[Le] DD MMMM YYYY à HH:mm'),
            value: eventData.id
          };
        }
      }
    }

    return {
      success: true,
      data
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const confirmOrder = async ({ orderid, contactid }) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'PATCH',
      endpoint: `/shop/orders/${orderid}`,
      data: {
        statusid: '1',
        contactid
      }
    });

    return {
      success: true,
      error: request.error,
      data: request.response
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const sendMollieToOrder = async ({ mollieID, orderID }) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'PATCH',
      endpoint: `/shop/orders/${orderID}`,
      data: {
        molliepaymentid: mollieID
      }
    });

    return {
      success: request.proxy_success,
      error: request.error,
      data: request.response
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const initPayment = async ({ description, total, orderid, stream }) => {
  try {
    const formData = new FormData();
    formData.append('payment_description', description);
    formData.append('payment_value', total);
    formData.append('callback_url', `${window.location.origin}/basket/message${stream ? '?stream=true' : ''}`);
    formData.append('utic_cart_id', orderid);

    const request = await apiRequest('index.php', formData);

    return {
      success: true,
      data: request
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

// eslint-disable-next-line
const getStatus = async ({ mollieID, orderID }) => {
  try {
    const formData = new FormData();
    formData.append('id', mollieID);

    const data = await apiRequest('status.php', formData);

    return {
      success: true,
      data
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

export {
  // eslint-disable-next-line
  requestStock,
  resetOrder,
  getOrder,
  confirmOrder,
  initPayment,
  getStatus,
  sendMollieToOrder
};
